import React from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";

export default function ChangePasswordModal({
  show,
  onHide,
  oldPwd,
  setOldPwd,
  newPwd,
  setNewPwd,
  confirmPwd,
  setConfirmPwd,
  pwdError,
  pwdSuccess,
  handleChangePwdSubmit
}) {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleChangePwdSubmit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Old Password</Form.Label>
            <Form.Control
              type="password"
              value={oldPwd}
              onChange={e => setOldPwd(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              value={newPwd}
              onChange={e => setNewPwd(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Confirm New Password</Form.Label>
            <Form.Control
              type="password"
              value={confirmPwd}
              onChange={e => setConfirmPwd(e.target.value)}
              required
            />
          </Form.Group>
          {pwdError && <Alert variant="danger">{pwdError}</Alert>}
          {pwdSuccess && <Alert variant="success">{pwdSuccess}</Alert>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button type="submit" variant="primary">Change Password</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
